import { render } from "./passResetView.vue?vue&type=template&id=1f31d620&scoped=true"
import script from "./passResetView.vue?vue&type=script&lang=js"
export * from "./passResetView.vue?vue&type=script&lang=js"

import "./passResetView.vue?vue&type=style&index=0&id=1f31d620&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f31d620"]])

export default __exports__